// Libs
import { createSelector } from 'reselect'
import _keys from 'lodash/keys'

import orders$ from './orders'

export default createSelector(
  [
    orders$,
  ],
  (orders) => {
    const firstKey = _keys(orders)[0]
    const lastKey = _keys(orders)[_keys(orders).length - 1]

    if (firstKey) {
      if (_keys(orders).length > 1) {
        return orders[lastKey]
      }

      return orders[firstKey]
    }

    return null
  }
)
